import { render, staticRenderFns } from "./withdraw_gatewayamb.vue?vue&type=template&id=ceab5e0a&scoped=true&"
import script from "./withdraw_gatewayamb.vue?vue&type=script&lang=js&"
export * from "./withdraw_gatewayamb.vue?vue&type=script&lang=js&"
import style0 from "./withdraw_gatewayamb.vue?vue&type=style&index=0&id=ceab5e0a&prod&scoped=true&lang=css&"
import style1 from "./withdraw_gatewayamb.vue?vue&type=style&index=1&id=ceab5e0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceab5e0a",
  null
  
)

export default component.exports